import { api } from "./api"

export const notificationList = async(addUrl = '')=>{
    return api.get(`/alert/list?${addUrl}`)
}